// extracted by mini-css-extract-plugin
export default {"SlideShowSlide":"imK94d","slideShowSlide":"imK94d","bg":"eF_jBL","borderNode":"wfm0FO"};